import { Box, Container, Grid, Hidden, makeStyles } from '@material-ui/core';
import { Link } from 'gatsby';
import React from 'react';
import { LinkedinIcon, TwitterIcon } from 'react-share';
import GettingStartedBlock from './footer-getting-started-block';

type FooterProps = {
  showGettingStartedBlock?: boolean;
  gettingStartedNegativeMargin?: number;
};

const useStyles = makeStyles(theme => ({
  root: (props: FooterProps) => ({
    background: `linear-gradient(129.23deg, ${theme.palette.secondary.main} 27.89%, ${theme.palette.secondary.dark} 77.04%)`,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    marginTop: props.showGettingStartedBlock
      ? theme.spacing(props.gettingStartedNegativeMargin)
      : 0,
  }),
  logoWrapper: {
    textAlign: 'center',
  },
  footerText: {
    color: 'rgba(255, 255, 255, 0.65)'
  },
  footerLink: {
    display: 'block',
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    '&:hover, &:focus': {
      textDecoration: 'none',
    },
    paddingTop: theme.spacing(1),
  }
}));

const Footer: React.FC<FooterProps> = props => {
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        {props.showGettingStartedBlock && (
          <GettingStartedBlock negativeMargin={props.gettingStartedNegativeMargin} />
        )}

        <Grid container className={classes.footerText}>
          <Hidden xsDown>
            <Grid item sm={3}>
              <img src="/img/footer-logo.svg" alt="Architect logo" />
            </Grid>

            <Grid item sm={3}>
              <div>Use Cases</div>
              <Link to="/use-cases/self-service-deployments" className={classes.footerLink}>
                Self-service deployments
              </Link>
              <Link to="/use-cases/private-developer-environments" className={classes.footerLink}>
                Private developer environments
              </Link>
              <Link to="/use-cases/preview-environments" className={classes.footerLink}>
                Preview environments
              </Link>
              <Link to="/use-cases/service-catalog" className={classes.footerLink}>
                Service catalog
              </Link>
              <Link to="/use-cases/security-compliance" className={classes.footerLink}>
                Security & compliance
              </Link>
            </Grid>
          </Hidden>
          <Grid item xs={6} sm={3}>
            <div>Company</div>
            <Link to="/pricing" className={classes.footerLink}>
              Pricing
            </Link>
            <Link to="/blog" className={classes.footerLink}>
              Blog
            </Link>
            <Link to="/careers" className={classes.footerLink}>
              Careers
            </Link>
            <a href="//cloud.architect.io/login" className={classes.footerLink}>
              Login
            </a>
          </Grid>
          <Grid item xs={6} sm={3}>
            <div>Legal</div>
            <Link to="/terms" className={classes.footerLink}>
              Terms
            </Link>
            <Link to="/privacy" className={classes.footerLink}>
                Privacy
            </Link>
          </Grid>
        </Grid>

        <Grid container justifyContent="center" className={classes.footerText}>
          <Grid item xs={12}>
            <Box textAlign='center' margin={2}>
              © {new Date().getFullYear()} Architect.io
            </Box>
          </Grid>
        </Grid>

        <Grid container justifyContent="center">
          <Grid item>
            <a target="_blank" href="https://mobile.twitter.com/architect_team" title="Architect Twitter">
              <TwitterIcon bgStyle={{ fill: 'transparent' }} iconFillColor="rgba(255, 255, 255, 0.65)" size={32} round />
            </a>
          </Grid>
          <Grid item>
            <a target="_blank" href="https://www.linkedin.com/company/architect-io/" title="Architect LinkedIn">
              <LinkedinIcon bgStyle={{ fill: 'transparent' }} iconFillColor="rgba(255, 255, 255, 0.65)" size={32} round />
            </a>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

Footer.defaultProps = {
  showGettingStartedBlock: true,
};

export default Footer;
